import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { ValidateOutputDataType } from '../schema/types';

const postValidateOutputData = async (
  request: ValidateOutputDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<void>(
      OutputDataUrl.OUTPUT_DATA_VALIDATION,
      request,
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useValidateOutputData = createApiMutationHook(
  ['validateOutputData'],
  getMutationFn(postValidateOutputData),
);
